// export const TILE_STYLES = {
//     'marketplace': { bg: '#E84855', fg: '#FFFFFF', icon: 'la-shopping-cart' },
//     'medicina_convenzionata': { bg: '#58B1FF', fg: '#FFFFFF', icon: 'la-stethoscope' },
//     'flussi': { bg: '#F5C242', fg: '#1B2A4E', icon: 'la-random' },
//     'hr': { bg: '#163B63', fg: '#FFFFFF', icon: 'la-user-cog' },
//     'faq': { bg: '#59b77a', fg: '#1B2A4E', icon: 'la-question-circle' },
// };

export const TILE_STYLES = {
    'marketplace': { bg: '#163B63', fg: '#FFFFFF', icon: 'la-file-signature' },
    'medicina_convenzionata': { bg: '#163B63', fg: '#FFFFFF', icon: 'la-stethoscope' },
    'flussi': { bg: '#163B63', fg: '#FFFFFF', icon: 'la-random' },
    'hr': { bg: '#163B63', fg: '#FFFFFF', icon: 'la-user-cog' },
    'faq': { bg: '#163B63', fg: '#FFFFFF', icon: 'la-question-circle' },
};

export const DEFAULT_TILE_STYLE = {
    bg: '#163B63', fg: '#FFFFFF', icon: 'la-th-large'
};
